export const LEADERBOARD = [
    {
        key: 'PoweredVoters',
        label: 'Powered Voters',
        description:
            'Top users who have most voting power, they are the crucial ones who have the biggest impact across the platform, including the Election, Acorn Drop ranking, Flagging decisions, etc.',
    },
    {
        key: 'AcornBuriers',
        label: 'Acorn Buriers',
        description:
            "Top users who buries most ACORNs, they aren't necessarily the ones having most voting power, but are still crucial to the platform.",
    },
    {
        key: 'Referrers',
        label: 'Referrers',
        description:
            'Top users who refer most users to the platform, they are the commendable ones who directly help the platform grow by expanding its community.',
    },
    {
        key: 'CouponGenerators',
        label: 'Coupon Generators',
        description:
            'Top users who generate most coupons, they are the commendable ones who directly help the platform grow by expanding its community.',
    },
    {
        key: 'Influencers',
        label: 'Influencers',
        description:
            'Top users who have most followers, they are the admirable ones who help the platform attractive by publishing most quality and impressive hypotheses (or evidences).',
    },
    {
        key: 'AcornEarners',
        label: 'Acorn Drop Earners',
        description:
            'Top users who earn most ACORNs, they are the ones with the best performance and true value on the Axiom.',
    },
    {
        key: 'HypothesisPublishers',
        label: 'Hypothesis Publishers',
        description: 'Top users who publish most hypotheses, they are the best idea generators.',
    },
    {
        key: 'EvidencePublishers',
        label: 'Evidence Publishers',
        description:
            'Top users who publish most evidences, they are the best discussants and critical thinkers.',
    },
    {
        key: 'HypothesisVoters',
        label: 'Hypothesis Voters',
        description:
            'Top users who vote most hypotheses, they are the ones who enjoy the hypotheses.',
    },
    {
        key: 'EvidenceVoters',
        label: 'Evidence Voters',
        description:
            'Top users who vote most evidences, they are the ones who enjoy the evidences.',
    },
]
